import { useCallback, useState } from "react";

export function useToast() {
  const [toasts, setToasts] = useState<any[]>([]);

  const toast = useCallback(
    (opts: {
      title: string;
      description?: string;
      status?: "success" | "error";
    }) => {
      const id = Math.random().toString(36).substr(2, 9);
      setToasts((prev) => [...prev, { ...opts, id }]);
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, 3000);
    },
    []
  );

  const ToastContainer = () => (
    <div className="absolute z-100 top-4 right-4 z-50 space-y-2">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`rounded px-4 py-2 shadow text-white ${
            t.status === "success" ? "bg-green-600" : "bg-red-600"
          }`}
        >
          <div className="font-bold">{t.title}</div>
          {t.description && <div className="text-sm">{t.description}</div>}
        </div>
      ))}
    </div>
  );

  return { toast, ToastContainer };
}
